import ACTION_TYPES from "../actions/type.action";

const initialState = {
	questions: {},
	responses: [],
	result:{}
};

const reducer = (state = initialState, action) => {
	const {
		type,
		payload
	} = action;

	switch (type) {
	
		case ACTION_TYPES.FETCH_IQ_QUESTIONS:
			return {
				...state,
				questions: [...payload]
			};
		case ACTION_TYPES.ADD_RESPONSES:
			return {
				...state,
				responses: payload
			};
		case ACTION_TYPES.GET_IQRESULT:
			return {
				...state,
				result: payload
			};

		default:
			return state;
	}
};

export default reducer;